import {mapState} from 'vuex';

export default {
    computed: {
        canManage() {
            return !!this.permissions.set_manage;
        },
        hasAccess() {
            return !!this.permissions.vinna_access;
        },
        isAdmin() {
            return !!this.permissions.vinna_admin;
        },
        permissionsLoaded() {
            return !!this.user.uuid;
        },
        ...mapState('toolbox', [
            'user',
            'permissions',
        ]),
    },
};
